import React from 'react'
import { Tag, Badge } from 'antd'

export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

export const getUrgencyTag = (urgency) => {
  let color
  switch (urgency) {
    case 'Emergency':
      color = 'red'
      break
    case 'Urgent':
      color = 'orange'
      break
    case 'Elective':
      color = 'green'
      break
    default:
      color = 'blue'
  }
  return <Tag color={color}>{urgency}</Tag>
}

export const getStatusBadge = (status) => {
  let statusProps
  switch (status) {
    case 'Ready':
      statusProps = { status: 'success', text: 'Ready' }
      break
    case 'Prep Delay':
      statusProps = { status: 'warning', text: 'Prep Delayed' }
      break
    case 'Scheduled':
      statusProps = { status: 'processing', text: 'Scheduled' }
      break
    case 'Pending':
      statusProps = { status: 'default', text: 'Pending' }
      break
    default:
      statusProps = { status: 'default', text: status }
  }
  return <Badge {...statusProps} />
}
